/** The references object of all modules needed for components initialization */
var references = {
    'storefront' : require('_core_ext/pages/storefront'),
    'reviews-carousel' : require('_core_ext/reviews-carousel')
};

module.exports = {
    'references' : references
};
